module.exports = __webpack_public_path__ + "./img/redirect_arrow.svg";